import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 text-2xl font-display font-bold text-white" data-id="element-202" data-mp="10d4pdocf48io">
      <div className="bg-zinc-900 border border-zinc-800 rounded px-3 py-2 min-w-[60px] text-center" data-id="element-203" data-mp="159bz7s7xq45w">
        {format(timeLeft.hours)}
      </div>
      <span className="text-[#c6ff2e]" data-id="element-204" data-mp="t2vbh0forx90">:</span>
      <div className="bg-zinc-900 border border-zinc-800 rounded px-3 py-2 min-w-[60px] text-center" data-id="element-205" data-mp="t1tqa34yhudk">
        {format(timeLeft.minutes)}
      </div>
      <span className="text-[#c6ff2e]" data-id="element-206" data-mp="12rdapd8bhwaj">:</span>
      <div className="bg-zinc-900 border border-zinc-800 rounded px-3 py-2 min-w-[60px] text-center" data-id="element-207" data-mp="12sokbtog1y9k">
        {format(timeLeft.seconds)}
      </div>
    </div>;
}